import { Option } from '../../../models/formModel';
import { KYC_LABELS } from '../constants/kycConstants';

export const getOptionKycStatus = (): Option[] => {
  let response: any[] = [];
  for (const [key, value] of Object.entries(KYC_LABELS)) {
    response.push({ label: value, value: key });
  }
  return response;
};
